import { AfterViewInit, Component } from '@angular/core';
import { GlobalSettingApiService } from 'src/app/api/admin/global-setting-api.service';
import { SyncService } from 'src/app/api/sync.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements AfterViewInit {

  copyright: string;
  copyrightYear = new Date().getFullYear();

  constructor(
    private globalSettingsApiSerivce: GlobalSettingApiService,
    private syncService: SyncService) {
  }

  ngAfterViewInit(): void {
    this.globalSettingsApiSerivce.getGlobalSettings().subscribe((res: any) => {
      this.syncService.updateFooter.next(true);
      this.copyright = res[1].settingValue;
    });
    this.syncService.updateFooter.subscribe(() => {
      this.globalSettingsApiSerivce.getGlobalSettings().subscribe((res: any) => {
        this.copyright = res[1].settingValue;
      });
    });
  }
}
